import { create } from 'zustand';

export const useDeadLetterStore = create((set) => ({
    items: [],
    metrics: null,
    selected: null,
    loading: false,
    metricsLoading: false,
    error: null,
    paginationData: { page: 1, pageSize: 20, total: 0, totalPages: 1 },
    searchParams: { status: 'pending', eventName: '', hopCountMin: '', page: 1, pageSize: 20 },
    setItems: (items) => set({ items }),
    setMetrics: (metrics) => set({ metrics }),
    setSelected: (selected) => set({ selected }),
    setLoading: (loading) => set({ loading }),
    setMetricsLoading: (metricsLoading) => set({ metricsLoading }),
    setError: (error) => set({ error }),
    setPaginationData: (paginationData) => set({ paginationData }),
    setSearchParams: (searchParams) => set((s) => ({ searchParams: { ...s.searchParams, ...searchParams } })),
}));

export default useDeadLetterStore;
